import type { FC } from "react";
import React from "react";
import {
  Body,
  Popover,
  PopoverContainer,
} from "@edreamsodigeo/prisma-design-system";
import { useTranslation } from "@edreamsodigeo/frontend-core";

import type { LightboxOfferSubtitleProps } from "~/components/acquisition/Lightbox/LightboxRevamp/components/LightboxOffer/contracts";
import { BgWrapperColor } from "~/components/acquisition/Lightbox/LightboxRevamp/components/LightboxOffer/contracts";
import { LightboxOfferSubscriptionWrapper } from "~/components/acquisition/Lightbox/LightboxRevamp/components/LightboxOffer/LightboxOfferSubscriptions/LightboxOfferSubscriptionWrapper";

export const LightboxOfferSubscriptionsPopover: FC<
  LightboxOfferSubtitleProps
> = ({ children }) => {
  const { t } = useTranslation();
  return (
    <PopoverContainer>
      <LightboxOfferSubscriptionWrapper color={BgWrapperColor.PLUS}>
        <Popover
          open={true}
          type={"positive"}
          align={"middle"}
          placement={"top"}
          size={"compact"}
        >
          <Body type={"xxSmall"}>
            {t("lightboxPrimeRevampDesktop.prime.desktop.pill")}
          </Body>
        </Popover>
        {children}
      </LightboxOfferSubscriptionWrapper>
    </PopoverContainer>
  );
};
